import axios from 'axios'
import { oktaAuth } from '../lib/okta-config'
export { oktaAuth }
export const REACT_APP_URL = window.location.origin

export const ADMIN_CONTACT = 'Support@agconnections.com'

export const loginInfo = {
  errorContact: ADMIN_CONTACT,
  API_URL: process.env.REACT_APP_API_URL
}

axios.interceptors.request.use(async config => {
  config.headers['x-api-key'] = '0'
  config.headers['Content-Type'] = 'application/json'
  try {
    const tokenManager = oktaAuth.tokenManager
    let accessToken = await tokenManager.get('accessToken')
    if (accessToken && oktaAuth.tokenManager.hasExpired(accessToken)) {
      accessToken = await tokenManager.renew('accessToken')
    }
    if (accessToken) {
      config.headers['x-user-token'] = accessToken.accessToken
    }
  } catch (err) {
    console.error('Okta token error: ', err)
  }
  return config
})

export const testSession = async (resolve, reject) => {
  try {
    const isAuthenticated = await oktaAuth.isAuthenticated()
    if (isAuthenticated) {
      const user = await oktaAuth.getUser()
      if (resolve) resolve(user)
    } else {
      if (reject) reject()
    }
  } catch (e) {
    console.error('AUTHCONFIG: FAILED TO LOAD SESSION: ', e)
    if (reject) reject()
  }
}
